import { SearchOutlined } from '@ant-design/icons';
import React, { useRef, useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useSelector } from 'react-redux';
import { Chip, Stack } from '@mui/material';
import './data-embarcador.css'
import firebase from '../../config/firebase';
import InputMask from 'react-input-mask';
import driverService from '../../service/driver.service';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalFilter from '../ModalFilter/ModalFilter';
import { resolveVehiclesForDrivers } from '../../util/vehicle/resolveVehicleForDriver';
import { GlobalSuccessModal, GlobalConfirmModal } from '../modalGlobal/modalGlobal';

require('firebase/auth')

const DataDriverTable = ({ data, cleanFilters, openFilters, onCleanFilterHandled, onOpenFilterHandled }) => {

  data.sort((a, b) => {
    return b.accountCreated?.seconds - a.accountCreated?.seconds || b.accountCreated?.nanoseconds - a.accountCreated?.nanoseconds;
  });

  const user = useSelector(state => state.user)

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const hasLoadedRef = useRef(false);
  const [dataComPlaca, setMotoristasComPlaca] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columnFilters, setColumnFilters] = useState({});
  const [sorterConfig, setSorterConfig] = useState({ columnKey: null, order: null });
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [driverToDelete, setDriverToDelete] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const storageKey = (uid, key) => `${uid}:${key}`;
  const driverModalFilterColumns = [
    { key: "name", label: "Nome", type: "text" },
    { key: "cpf", label: "CPF", type: "text" },
    { key: "placa", label: "Placa Veículo", type: "text" },
    { key: "email", label: "E-mail", type: "text" },
    { key: "statusDriver", label: "Status", type: "select" },
  ];
  const driverStatusOptions = [
    { value: "informed", label: "Pendente" },
    { value: "incomplete", label: "Incompleto" },
    { value: "failed", label: "Rejeitado" },
    { value: "authorized", label: "Autorizado" },
  ];


  const fetchData = async () => {
    setLoading(true);
    try {
      if (!data) {
        setLoading(false);
        return;
      }

      // 🔹 Filtro de acesso
      let filteredData = [];

      if (user.viewALL) {
        filteredData = data;
      }
      else {
        const affiliateUids = Array.isArray(user.uidShipperAffiliates)
          ? user.uidShipperAffiliates
          : [];
        const primaryUid = user.uidShipper ? [user.uidShipper] : [];
        const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

        filteredData = await Promise.all(
          data.map(async (motorista) => {
            try {
              const documentsSnapshot = await driverService.getDriverDocuments(motorista.id);

              // se retorna QuerySnapshot (array de docs)
              if (documentsSnapshot.docs && Array.isArray(documentsSnapshot.docs)) {
                const docData = documentsSnapshot.docs[0]?.data();
                const shipperUidField = docData?.shipper?.uid;

                if (!shipperUidField) {
                  return null;
                }

                if (Array.isArray(shipperUidField)) {
                  return shipperUidField.some((uid) => uids.includes(uid)) ? motorista : null;
                } else {
                  return uids.includes(shipperUidField) ? motorista : null;
                }
              }
              // se retorna DocumentSnapshot (um doc)
              else if (documentsSnapshot.data) {
                const docData = documentsSnapshot.data();
                const shipperUidField = docData?.allData?.shipper?.uid;

                if (!shipperUidField) return null;

                if (Array.isArray(shipperUidField)) {
                  return shipperUidField.some((uid) => uids.includes(uid)) ? motorista : null;
                } else {
                  return uids.includes(shipperUidField) ? motorista : null;
                }
              }

              return null;
            } catch (innerError) {
              console.error(`Erro ao filtrar motorista ${motorista.id}:`, innerError);
              return null;
            }
          })
        ).then(results => results.filter(item => item !== null));
      }

      // 🔹 Placas via batch na coleção vehicle (evita N+1)
      const driverUids = filteredData.map((motorista) => motorista.id);
      let vehicleByDriver = new Map();
      try {
        vehicleByDriver = await resolveVehiclesForDrivers(driverUids);
      } catch (batchError) {
        console.error("Erro ao resolver veículos em lote:", batchError);
      }

      const motoristasAtualizados = filteredData.map((motorista) => {
        const vehicle = vehicleByDriver.get(motorista.id);
        const placa = vehicle?.vehiclePlate || "Sem placa";
        return { ...motorista, placa };
      });

      setMotoristasComPlaca(motoristasAtualizados);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar dados dos motoristas:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [data]);

  //Persistência de filtros
  //Carregamento de filtros
  useEffect(() => {
    if (!user?.uid) return;

    try {
      const savedColumnFilters = localStorage.getItem(
        storageKey(user.uid, "driverColumnFilters"),
      );
      const savedSorter = localStorage.getItem(
        storageKey(user.uid, "driverTableSorter"),
      );

      setColumnFilters(savedColumnFilters ? JSON.parse(savedColumnFilters) : {});
      setSorterConfig(
        savedSorter
          ? JSON.parse(savedSorter)
          : { columnKey: null, order: null },
      );
    } catch (error) {
      console.error("Erro ao carregar filtros do localStorage:", error);
      setColumnFilters({});
      setSorterConfig({ columnKey: null, order: null });
    } finally {
      hasLoadedRef.current = true;
    }
  }, [user?.uid]);

  //Salvamento de filtros
  useEffect(() => {
    if (!hasLoadedRef.current || !user?.uid) return;

    const hasActiveColumnFilters = Object.values(columnFilters || {}).some(
      (values) => Array.isArray(values) && values.length > 0
    );

    if (hasActiveColumnFilters) {
      localStorage.setItem(
        storageKey(user.uid, "driverColumnFilters"),
        JSON.stringify(columnFilters),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "driverColumnFilters"));
    }

    if (sorterConfig?.columnKey && sorterConfig?.order) {
      localStorage.setItem(
        storageKey(user.uid, "driverTableSorter"),
        JSON.stringify(sorterConfig),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "driverTableSorter"));
    }
  }, [user?.uid, columnFilters, sorterConfig]);

  useEffect(() => {
    if (cleanFilters) {
      setSearchText('');
      setSearchedColumn('');
      setColumnFilters({});
      setSorterConfig({ columnKey: null, order: null });

      if (user?.uid) {
        localStorage.removeItem(storageKey(user.uid, "driverColumnFilters"));
        localStorage.removeItem(storageKey(user.uid, "driverTableSorter"));
      }

      onCleanFilterHandled?.();
    }
  }, [cleanFilters, user?.uid, onCleanFilterHandled]);

  //Entrada de dados
  useEffect(() => {
    if (openFilters) {
      setOpenModalFilter(true);
      onOpenFilterHandled?.();
    }
  }, [openFilters, onOpenFilterHandled]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length > 0) {
      if (selectedKeys[0].trim().length > 0) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
        setColumnFilters((prev) => ({
          ...prev,
          [dataIndex]: selectedKeys,
        }));
      } else {
        confirm();
        setSearchText('');
        setSearchedColumn(dataIndex);
        setColumnFilters((prev) => ({
          ...prev,
          [dataIndex]: null,
        }));
      }
    } else {
      confirm();
      setSearchText('');
      setSearchedColumn(dataIndex);
      setColumnFilters((prev) => ({
        ...prev,
        [dataIndex]: null,
      }));
    }
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    setSearchText('');
    setColumnFilters((prev) => {
      const nextFilters = { ...prev };
      delete nextFilters[dataIndex];
      return nextFilters;
    });
  };

  const getDriverStatus = (record) => {
    const status = record?.statusDriver?.toString().toLowerCase();

    switch (status) {
      case 'informed':
      case 'incomplete':
      case 'failed':
        return status;
      default:
        return 'authorized';
    }
  };

  const getDriverStatusLabel = (status) => {
    switch (status) {
      case 'informed':
        return 'Pendente';
      case 'incomplete':
        return 'Incompleto';
      case 'failed':
        return 'Rejeitado';
      default:
        return 'Autorizado';
    }
  };

  const getStatusSortWeight = (status) => {
    const statusWeight = {
      failed: 1,
      incomplete: 2,
      informed: 3,
      authorized: 4,
    };

    return statusWeight[status] ?? 99;
  };

  const doesColumnFilterMatch = (record, dataIndex, value) => {
    if (dataIndex === 'cpf') {
      const cleanValue = String(value).replace(/[^\w]/g, '').trim().toLowerCase();
      const documentNumber = record?.cpf
        ? record.cpf.toString().replace(/[^\w]/g, '').toLowerCase().trim()
        : '';
      return documentNumber.includes(cleanValue);
    }

    if (dataIndex === 'statusDriver') {
      return getDriverStatus(record) === String(value).toLowerCase();
    }

    return record?.[dataIndex]?.toString().toLowerCase().includes(String(value).toLowerCase());
  };

  const getDataFilteredByNonStatusFilters = () => {
    const baseData = dataComPlaca || [];

    const activeNonStatusFilters = Object.entries(columnFilters || {}).filter(
      ([key, values]) =>
        key !== 'statusDriver' && Array.isArray(values) && values.length > 0
    );

    if (!activeNonStatusFilters.length) {
      return baseData;
    }

    return baseData.filter((record) =>
      activeNonStatusFilters.every(([dataIndex, values]) =>
        values.some((value) => doesColumnFilterMatch(record, dataIndex, value))
      )
    );
  };

  const getUniqueStatusValues = () => {
    const dataFilteredByNonStatus = getDataFilteredByNonStatusFilters();
    const uniqueValues = new Set(
      dataFilteredByNonStatus.map((record) => getDriverStatus(record))
    );

    return Array.from(uniqueValues).sort((a, b) => {
      const diff = getStatusSortWeight(a) - getStatusSortWeight(b);
      return diff !== 0 ? diff : a.localeCompare(b);
    });
  };

  const getStatusFilterProps = () => ({
    filters: getUniqueStatusValues().map((status) => ({
      text: getDriverStatusLabel(status),
      value: status,
    })),
    filterSearch: true,
    filterMultiple: true,
    onFilter: (value, record) => getDriverStatus(record) === value,
  });

  const handleApplyCustomFilter = (filter) => {
    const newFilters = {};

    if (filter.conditions && filter.conditions.length > 0) {
      filter.conditions.forEach(condition => {
        const { column, operator, value } = condition;
        if (!column) return;

        if (column === 'statusDriver') {
          if (operator === 'in' && Array.isArray(value) && value.length > 0) {
            newFilters[column] = value;
          } else if (operator === 'equals' && value) {
            newFilters[column] = [value];
          }
          return;
        }

        if (
          (operator === 'contains' ||
            operator === 'equals' ||
            operator === 'startsWith' ||
            operator === 'endsWith') &&
          value !== undefined &&
          value !== null &&
          value !== ''
        ) {
          newFilters[column] = [String(value)];
        }
      });
    }

    setColumnFilters(newFilters);
  };

  function renderStatusColor(status) {
    const chipStyle = {
      minWidth: '100px',
      maxWidth: '150px',
      borderRadius: '8px',
    };

    const commonChip = (label, color) => (
      <Stack direction="row" spacing={1}>
        <Chip label={label} color={color} style={chipStyle} />
      </Stack>
    );

    switch (status) {
      case 'informed':
        return commonChip("Pendente", 'warning');
      case 'incomplete':
        return commonChip("Incompleto", 'error');
      case 'failed':
        return commonChip("Rejeitado", 'error');
      default:
        return commonChip("Autorizado", 'primary');

    }
  }

  const handleDeleteClick = (id) => {
    setDriverToDelete(id);
    setOpenConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmModal(false);
    if (!driverToDelete) return;

    try {
      await firebase.firestore()
        .collection('drivers_users')
        .doc(driverToDelete)
        .delete();
      setOpenSuccessModal(true);
      fetchData();
    } catch (error) {
      console.error("Erro ao excluir motorista:", error);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filteredValue: columnFilters[dataIndex] || null,
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilter: (value, record) => doesColumnFilterMatch(record, dataIndex, value),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      sortOrder: sorterConfig.columnKey === 'name' ? sorterConfig.order : null,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      ...getColumnSearchProps('cpf'),
      sortOrder: sorterConfig.columnKey === 'cpf' ? sorterConfig.order : null,
      sorter: (a, b) => a.cpf.localeCompare(b.cpf),
      render: (text) => {
        return <InputMask mask="999.999.999-99" value={text} disabled style={{
          border: 'none',
          backgroundColor: 'transparent',
          width: 'auto',
          padding: '0 5px',
          fontSize: '14px',
          color: '#444',
        }} />;
      },
    },
    {
      title: 'Placa Veiculo',
      dataIndex: 'placa',
      key: 'placa',
      ...getColumnSearchProps('placa'),
      sortOrder: sorterConfig.columnKey === 'placa' ? sorterConfig.order : null,
      sorter: (a, b) => a.placa.localeCompare(b.placa),
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
      ...getColumnSearchProps('email'),
      sortOrder: sorterConfig.columnKey === 'email' ? sorterConfig.order : null,
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Status',
      dataIndex: 'statusDriver',
      key: 'statusDriver',
      filteredValue: columnFilters.statusDriver
        ? columnFilters.statusDriver
        : null,
      ...getStatusFilterProps(),
      sortOrder: sorterConfig.columnKey === 'statusDriver' ? sorterConfig.order : null,
      render: (_, value) => (
        <span>
          {renderStatusColor(getDriverStatus(value))}
        </span>
      ),
      sorter: (a, b) => {
        const statusA = getDriverStatus(a);
        const statusB = getDriverStatus(b);

        const statusWeightDiff = getStatusSortWeight(statusA) - getStatusSortWeight(statusB);
        if (statusWeightDiff !== 0) {
          return statusWeightDiff;
        }

        return statusA.localeCompare(statusB);
      },
    },
    {
      title: 'Ações',
      // dataIndex: 'data',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {
            user?.permissoes?.driver?.isEdit || user?.permissoes?.motorista?.editar ?
              (
                <Link to={'/driverList/' + record.id}>
                  <EditOutlinedIcon />
                </Link>
              )
              :
              (
                <Link to={'/driverList/' + record.id} state={{ viewOnly: true }}>
                  <VisibilityIcon />
                </Link>
              )
          }
          {
            user?.permissoes?.driver?.isDelete || user?.permissoes?.motorista?.excluir ?
              (
                <DeleteOutlinedIcon onClick={() => handleDeleteClick(record.id)} color='error' style={{ cursor: "pointer" }} />
              )
              :
              (
                ""
              )
          }
        </Space>
      ),
    },
  ];
  return (
    <>
      <ModalFilter
        visible={openModalFilter}
        onClose={() => setOpenModalFilter(false)}
        onApply={handleApplyCustomFilter}
        availableColumns={driverModalFilterColumns}
        selectOptionsMap={{ statusDriver: driverStatusOptions }}
        storageKeySuffix="driverCustomFilters"
      />
      <Table
        columns={columns}
        dataSource={dataComPlaca}
        loading={loading}
        onChange={(_, filters, sorter) => {
          setColumnFilters(filters || {});

          if (!sorter || Array.isArray(sorter)) {
            setSorterConfig({ columnKey: null, order: null });
            return;
          }

          setSorterConfig({
            columnKey: sorter.columnKey || sorter.field || null,
            order: sorter.order || null,
          });
        }}
      />
      <GlobalConfirmModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Deseja mesmo excluir?"
        subtitle="Esta ação não poderá ser desfeita."
      />
      <GlobalSuccessModal
        open={openSuccessModal}
        handleClose={() => setOpenSuccessModal(false)}
        title="Motorista excluído com sucesso!"
      />
    </>
  );

};
export default DataDriverTable;